import { isDefined } from "@clipboard-health/util-ts";
import { type SxProps, type Theme } from "@mui/material";

import { BoostedPayLabel } from "./BoostedPayLabel";
import { TotalPayLabel } from "./TotalPayLabel";

export interface TotalPayOrBoostLabelProps {
  totalPay: string | undefined;
  isLoading?: boolean;
  totalWithBoostPay?: string | undefined;
  sx?: SxProps<Theme>;
}

export function TotalPayOrBoostLabel(props: TotalPayOrBoostLabelProps) {
  const { totalPay, isLoading, totalWithBoostPay, sx } = props;

  if (isDefined(totalWithBoostPay)) {
    return (
      <BoostedPayLabel
        totalPayBeforeBoost={totalPay}
        totalWithBoostPay={totalWithBoostPay}
        includePayBeforeBoost={false}
      />
    );
  }

  return <TotalPayLabel totalPay={totalPay} isLoading={isLoading} sx={sx} />;
}
